export const estadoIn =({
    Abierta: 'Crear Acta',
    Cerrada: 'Entregado'
})

export const estados=({
    Abierta: 'Abierta',
    Cerrada: 'Cerrado',
    Anulado: 'Anulado'
})